import { render, staticRenderFns } from "./SliderHome.vue?vue&type=template&id=0da93b84&scoped=true"
import script from "./SliderHome.vue?vue&type=script&lang=js"
export * from "./SliderHome.vue?vue&type=script&lang=js"
import style0 from "./SliderHome.vue?vue&type=style&index=0&id=0da93b84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da93b84",
  null
  
)

export default component.exports